export default __webpack_public_path__ + "static/media/creatures.c32112ee.png";